import { Opportunity, Project } from '../types/api';

/**
 * What a What-If scenario is built for: a Redmine project, or an opportunity
 * (prospective work that is not in Redmine). The two are kept separate - they
 * have independent ids, endpoints and saved scenarios - so the kind always
 * travels with the id.
 */
export type WorkScope =
  | { kind: 'project'; project: Project }
  | { kind: 'opportunity'; opportunity: Opportunity };

/** Stable identity for effects and React keys; ids alone can overlap across kinds. */
export const workScopeKey = (scope: WorkScope | null): string =>
  !scope
    ? ''
    : scope.kind === 'project'
      ? `project:${scope.project.id}`
      : `opportunity:${scope.opportunity.id}`;

/** Noun for the kind of work, for use in headings and labels. */
export const workTypeLabel = (opportunity: boolean): string =>
  opportunity ? 'Opportunity' : 'Project';
